import { forwardRef } from 'react';
import { Typography } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { PanelTitle } from 'src/components/PanelTitle';

import { useStyles } from './useStyles';

export const StaticPanel = forwardRef(
  (
    {
      className,
      title,
      subtitle,
      hint,
      children,
      titleBold,
      titleOptional,
      titleModified,
      titleStonlyId,
      classes,
      onBlur,
      ...restProps
    },
    ref
  ) => {
    const styles = useStyles({ classes });
    const showTitleWrapper = Boolean(title);

    return (
      <div
        className={cx(styles.root, className)}
        ref={ref}
        onBlur={onBlur ? onBlur : null}
        {...restProps}
      >
        {showTitleWrapper && (
          <div className={styles.titleWrapper}>
            {title && (
              <PanelTitle
                className={styles.title}
                classes={{ title: classes?.title, titleTooltip: classes?.titleTooltip }}
                title={title}
                subtitle={subtitle}
                hint={hint}
                optional={titleOptional}
                modified={titleModified}
                titleStonlyId={titleStonlyId}
                titleBold={titleBold}
              />
            )}
          </div>
        )}

        {subtitle && <Typography className={styles.subtitle}>{subtitle}</Typography>}

        {children && <div className={styles.childrenWrapper}>{children}</div>}
      </div>
    );
  }
);

StaticPanel.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  hint: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  children: PropTypes.node,
  titleBold: PropTypes.bool,
  titleOptional: PropTypes.bool,
  titleModified: PropTypes.bool,
  titleStonlyId: PropTypes.string,
  classes: PropTypes.shape({
    title: PropTypes.string,
    titleTooltip: PropTypes.string,
  }),
  onBlur: PropTypes.func,
};
StaticPanel.defaultProps = {
  className: '',
  title: '',
  subtitle: '',
  hint: '',
  children: null,
  titleBold: false,
  titleOptional: false,
  titleModified: false,
  titleStonlyId: '',
  classes: {},
  onBlur: null,
};
